import { getLang, setLang, languages } from '@/utils/langs'

const global = {
  state: {
    showingHeader: true,
    showingFooter: true,
    showingH5Header: true,
    showingH5Backbar: false,
    callBack: null,
    globalLang: getLang(),
    languages
  },
  mutations: {
    // 存储全局语言
    SET_LANGUAGE: (state, data) => {
      state.globalLang = data || state.globalLang
      // sessionStorage存储语言
      setLang(state.globalLang)
    },
    SET_HEADER_STATUS: (s, status) => {
      s.showingHeader = status;
    },
    SET_FOOTER_STATUS: (s, status) => {
      s.showingFooter = status;
    },
    SET_H5HEADER_STATUS: (s, status) => {
      s.showingH5Header = status;
    },
    SET_H5BACKBAR_STATUS: (s, status) => {
      s.showingH5Backbar = status;
    }
  },
  actions: {
    // 设置语言
    setGlobalLang({ commit }, status) {
      commit("SET_LANGUAGE", status);
    },
    setHeaderStatus({ commit }, status) {
      commit("SET_HEADER_STATUS", status);
    },
    setFooterStatus({ commit }, status) {
      commit("SET_FOOTER_STATUS", status);
    },
    setH5HeaderStatus({ commit }, status) {
      commit("SET_H5HEADER_STATUS", status);
    },
    setH5BackbarStatus({ commit }, status) {
      commit("SET_H5BACKBAR_STATUS", status);
    }
  },
  getters: {
    globalLang: s => s.globalLang,
    showingHeader: s => s.showingHeader,
    showingFooter: s => s.showingFooter,
    showingH5Header: s => s.showingH5Header,
    showingH5Backbar: s => s.showingH5Backbar,
    languages: s => s.languages
  }
};

export default global;
